import React from "react";
import Logo from "assets/png/Sigma.png";
import "assets/css/Menu.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import { Navbar, NavDropdown, Nav } from "react-bootstrap";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import { NavLink } from "react-router-dom";
import Translate from "components/translate/Translate";
import { GetTranslation } from "../../redux/actions/TranslatorActions";
import { connect } from "react-redux";

function Header(oProps) {
  const { fLogout, oUser, oTranslator } = oProps;

  const handleTranslate = (key) => {
    const { sLanguage } = oTranslator;
    return GetTranslation(sLanguage, key);
  }

  return oUser ? (
    <Navbar collapseOnSelect expand="lg" bg="light" variant="light" className="shadow">
      <NavLink to="/" exact>
        <img src={Logo} width={80} alt="Inicio" />
      </NavLink>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          <NavDropdownMenu title={handleTranslate('DATA_MAINTENANCE')} id="collasible-nav-dropdown">
            <DropdownSubmenu href="#" title={handleTranslate('DATA_MAINTENANCE_HOLDER')}>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/clients"
                  activeClassName="active"
                  exact
                >
                  <Translate label="CLIENTS" />
                </NavLink>
              </NavDropdown.Item>

              <NavDropdown.Item as={'span'}>

                <NavLink
                  className="dropdown-item"
                  to="/nurses"
                  activeClassName="active"
                  exact
                >
                  <Translate label="NURSES" />
                </NavLink>

              </NavDropdown.Item>

              <NavDropdown.Item as={'span'}>

                <NavLink
                  className="dropdown-item"
                  to="/individuals"
                  activeClassName="active"
                  exact
                >
                  <Translate label="INDIVIDUALS" />
                </NavLink>

              </NavDropdown.Item>

              <NavDropdown.Item as={'span'}>

                <NavLink
                  className="dropdown-item"
                  to="/doctors"
                  activeClassName="active"
                  exact
                >
                  <Translate label="DOCTORS" />
                </NavLink>

              </NavDropdown.Item>

              <NavDropdown.Item as={'span'}>

                <NavLink
                  className="dropdown-item"
                  to="/witnesses"
                  activeClassName="active"
                  exact
                >
                  <Translate label="WITNESSES" />
                </NavLink>

              </NavDropdown.Item>



            </DropdownSubmenu>
            <DropdownSubmenu href="#" title={handleTranslate('DATA_MAINTENANCE_TYPES')}>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/clinical/analysis/types"
                  activeClassName="active"
                  exact
                >
                  <Translate label="TYPES_OF_CLINICAL_ANALYSIS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/coordination/types"
                  activeClassName="active"
                  exact
                >
                  <Translate label="COORDINATION_TYPES" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/document/types"
                  activeClassName="active"
                  exact
                >
                  <Translate label="TYPES_OF_DOCUMENTS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/studies/paternity/types"
                  activeClassName="active"
                  exact
                >
                  <Translate label="TYPES_OF_PATERNITY_STUDIES" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/sample/types"
                  activeClassName="active"
                  exact
                >
                  <Translate label="SAMPLE_TYPES" />
                </NavLink>
              </NavDropdown.Item>
            </DropdownSubmenu>
            <DropdownSubmenu href="#" title={handleTranslate('DATA_MAINTENANCE_OTHER')}>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/specialties"
                  activeClassName="active"
                  exact
                >
                  <Translate label="MEDICAL_SPECIALTIES" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/stages"
                  activeClassName="active"
                  exact
                >
                  <Translate label="STAGES" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/genders"
                  activeClassName="active"
                  exact
                >
                  <Translate label="GENDERS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/medical/institutions"
                  activeClassName="active"
                  exact
                >
                  <Translate label="MEDICAL_INSTITUTIONS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/locations"
                  activeClassName="active"
                  exact
                >
                  <Translate label="LOCATIONS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/markers"
                  activeClassName="active"
                  exact
                >
                  <Translate label="GENETIC_MARKERS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/extraction/methods"
                  activeClassName="active"
                  exact
                >
                  <Translate label="EXTRACTION_METHODS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/offices"
                  activeClassName="active"
                  exact
                >
                  <Translate label="OFFICES" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/ethnic/origins"
                  activeClassName="active"
                  exact
                >
                  <Translate label="ETHNIC_ORIGIN" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/countries"
                  activeClassName="active"
                  exact
                >
                  <Translate label="COUNTRIES" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/kinships"
                  activeClassName="active"
                  exact
                >
                  <Translate label="KINSHIPS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/products"
                  activeClassName="active"
                  exact
                >
                  <Translate label="PRODUCTS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/appointment/sectors"
                  activeClassName="active"
                  exact
                >
                  <Translate label="APPOINTMENT_SECTORS" />
                </NavLink>
              </NavDropdown.Item>
              <NavDropdown.Item as={'span'}>
                <NavLink
                  className="dropdown-item"
                  to="/techniques"
                  activeClassName="active"
                  exact
                >
                  <Translate label="TECHNIQUES" />
                </NavLink>
              </NavDropdown.Item>

            </DropdownSubmenu>

          </NavDropdownMenu>
          <NavDropdownMenu title={handleTranslate('CLINICAL_ANALYZES')} id="collasible-nav-dropdown">
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/clinical/analysis"
                activeClassName="active"
                exact
              >
                <Translate label="LIST" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/clinical/analysis/add"
                activeClassName="active"
                exact
              >
                <Translate label="NEW" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/clinical/analysis/outbox"
                activeClassName="active"
                exact
              >
                <Translate label="OUTBOX" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/clinical/analysis/inbox"
                activeClassName="active"
                exact
              >
                <Translate label="INBOX" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/clinical/analysis/import"
                activeClassName="active"
                exact
              >
                <Translate label="CREATE_ANALYSIS_FROM_SPREADSHEET" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/clinical/analysis/import/results"
                activeClassName="active"
                exact
              >
                <Translate label="IMPORT_RESULTS_FROM_SPREADSHEET" />
              </NavLink>
            </NavDropdown.Item>
          </NavDropdownMenu>
          <NavDropdownMenu title={handleTranslate('PATERNITY_STUDIES')} id="collasible-nav-dropdown">
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/studies/paternity"
                activeClassName="active"
                exact
              >
                <Translate label="LIST" />
              </NavLink>
            </NavDropdown.Item>

            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/studies/paternity/add"
                activeClassName="active"
                exact
              >
                <Translate label="NEW" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/studies/paternity/outbox"
                activeClassName="active"
                exact
              >
                <Translate label="OUTBOX" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/studies/paternity/inbox"
                activeClassName="active"
                exact
              >
                <Translate label="INBOX" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/studies/paternity/import/genemapper"
                activeClassName="active"
                exact
              >
                <Translate label="IMPORT_GENEMAPPER" />
              </NavLink>
            </NavDropdown.Item>
          </NavDropdownMenu>
          <NavDropdownMenu title={handleTranslate('PROSPECTS')} id="collasible-nav-dropdown">
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/prospects"
                activeClassName="active"
                exact
              >
                <Translate label="LIST" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/prospects/add"
                activeClassName="active"
                exact
              >
                <Translate label="NEW" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/prospects/import"
                activeClassName="active"
                exact
              >
                <Translate label="CREATE_PROSPECTS_FROM_SPREADSHEET" />
              </NavLink>
            </NavDropdown.Item>
          </NavDropdownMenu>
          <NavDropdownMenu title={handleTranslate('SECURITY')} id="collasible-nav-dropdown">
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/tasks"
                activeClassName="active"
                exact
              >
                <Translate label="TASKS" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/users"
                activeClassName="active"
                exact
              >
                <Translate label="USERS" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/roles"
                activeClassName="active"
                exact
              >
                <Translate label="ROLES" />
              </NavLink>
            </NavDropdown.Item>

          </NavDropdownMenu>
          <NavDropdownMenu title={handleTranslate('TOOLS')} id="collasible-nav-dropdown">
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to="/system/params"
                activeClassName="active"
                exact
              >
                <Translate label="SYSTEM_PARAMS" />
              </NavLink>
            </NavDropdown.Item>

          </NavDropdownMenu>
          <NavDropdown.Item as={'div'} className="nav-item" style={{ padding: "0" }}>
            <NavLink
              className="nav-link"
              to="/calendar"
              activeClassName="active"
              exact
            >
              <Translate label="CALENDAR" />
            </NavLink>
          </NavDropdown.Item>
          <NavDropdownMenu title={`${handleTranslate('USER')}: ${oUser.fullname} - ${oUser?.offices[0]?.role?.name}`} id="collasible-nav-dropdown">
            <NavDropdown.Item as={'span'}>
              <NavLink
                className="dropdown-item"
                to={`/users/${oUser.id}`}
                activeClassName="active"
                exact
              >
                <Translate label="CHANGE_PASSWORD" />
              </NavLink>
            </NavDropdown.Item>
            <NavDropdown.Item as={'span'} onClick={fLogout}>
              <Translate label="LOGOUT" options={{ 'value': oUser.username }} />
            </NavDropdown.Item>

          </NavDropdownMenu>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  ) : null;
}
const mapStateToProps = (oState) => ({
  oTranslator: oState.TranslatorReducer,
});
export default connect(mapStateToProps)(Header);